import type { ResponsiveGridLayoutProps } from 'react-grid-layout';

/** Configuration options used to customize react-grid-layout. */
export const panelGridLayoutConfig: Required<
  Pick<ResponsiveGridLayoutProps, 'margin' | 'containerPadding' | 'rowHeight'>
> & { cols: number; draggableHandle: string } = {
  margin: [12, 12],
  containerPadding: [0, 0],
  cols: 24,
  rowHeight: 40,
  draggableHandle: 'panelDragHandle',
};
